import { useCustomViewDialogStore } from "csi/middleware/customView/CustomViewDialogStore";
import CheckboxOption from "csi/middleware/customView/options/CheckboxOption";
import { isDefined } from "csi/utility/coreUtility";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import SizeChartDataSheetCustomViewOptionsStore from "./SizeChartDataSheetCustomViewOptionsStore";

const SizeChartDataSheetOptions: FunctionComponent = observer(function SizeChartDataSheetOptions() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		setSizeChartPrintSubSizeRanges,
		options: {
			sizeChartPrintSubSizeRanges,
		},
	} = optionsStore as SizeChartDataSheetCustomViewOptionsStore;

	return (
		<>
			{isDefined(sizeChartPrintSubSizeRanges) && (
				<CheckboxOption
					dataCsiAutomation="CustomViewDataSheetPrintDimensionsPerSubSizeRange"
					label="CustomViewDataSheetPrintDimensionsPerSubSizeRange"
					onChange={setSizeChartPrintSubSizeRanges}
					optionValue={sizeChartPrintSubSizeRanges}
					paddingLeft={0}
				/>
			)}
		</>
	);
});

export default SizeChartDataSheetOptions;